module.exports = __webpack_public_path__ + "mobile/img/img7-618.edd636f7.png";